import { useState } from "react";
import { useNavigate } from 'react-router-dom';
import { Logo } from "./navigation/Logo";
import { NavLinks } from "./navigation/NavLinks";
import { MobileMenu } from "./navigation/MobileMenu";
import { NavButton } from "./navigation/NavButton";
import { MobileMenuToggle } from "./navigation/MobileMenuToggle";
import { useScrollEffect } from "@/hooks/useScrollEffect";

export const Navigation = () => {
  const isScrolled = useScrollEffect(10);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const navigate = useNavigate();

  const handleLoginClick = () => {
    navigate('/login');
  };
  
  const handleSignupClick = () => {
    navigate('/invite-code');
  };

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
      isScrolled ? "brutal-nav" : "bg-transparent"
    }`}>
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-16">
          <div className="flex-shrink-0">
            <Logo />
          </div>

          <div className="hidden md:flex items-center justify-center flex-1 mx-8">
            <NavLinks scrollToSection={scrollToSection} />
          </div>

          <div className="hidden md:flex items-center space-x-4">
            <NavButton onClick={handleLoginClick}>
              Login
            </NavButton>
            <NavButton onClick={handleSignupClick}>
              Sign Up
            </NavButton>
          </div>

          <div className="md:hidden">
            <MobileMenuToggle onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} />
          </div>
        </div>

        <MobileMenu 
          isOpen={isMobileMenuOpen} 
          scrollToSection={scrollToSection} 
          handleLoginClick={handleLoginClick}
          handleSignupClick={handleSignupClick}
        />
      </div>
    </nav>
  );
};
